





















































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import FuncaoDescricao from '@/factories/ProfissionalExecutanteFuncaoDescricao'
import _ from 'lodash'

@Component

export default class ComponentRelatorioDetalhe extends Vue {
  @Prop(Object) relatorio

  formatarQuantidade(value) {
    return _.padStart(value, 2, '0')
  }

  formatarQuantidadeTotalPaciente(producao) {
    // @ts-ignore
    return _.padStart(_.sumBy(producao.procedimento, 'quantidade'), 2, '0')
  }

  formatarValor(valor) {
    return `R$ ${this.formatDecimalNumber(valor, 2, '.', ',')}`
  }

  formatarValorTotalPaciente(producao) {
    return `R$ ${this.formatDecimalNumber(_.sumBy(producao.procedimento, 'valorTotal'), 2, '.', ',')}`
  }

  formatDecimalNumber(value, numberOfDecimalPlaces, thousandSeparator, decimalSeparator) {
    const tChar = thousandSeparator || '.'
    const dChar = decimalSeparator || ','

    const parts = String(_.round(Number(value), numberOfDecimalPlaces).toFixed(numberOfDecimalPlaces)).split('.')
    return String(parts[0]).replace(/\B(?=(\d{3})+(?!\d))/g, tChar) + dChar + parts[1]
  }

  FuncaoDescricao(grau) {
    return FuncaoDescricao.funcao(grau)
  }
}
